import { AppLayoutStore as LibAppLayoutStore } from "@intrasync/stores";

import type RootStore from "./RootStore";

/**
 * MIGRATED: the implementation now lives in @intrasync/stores.
 *
 * `LayoutOptions` and `SearchCategory` are declared inside the package's
 * AppLayoutStore.d.ts but are NOT re-exported from the package root barrel
 * (tsconfig moduleResolution: "Node" cannot reach '@intrasync/stores/specialized'),
 * so they are re-declared here verbatim to preserve this module's export shape.
 * The library's own SearchCategory member values are identical, and its
 * LayoutOptions is this interface plus two optional fields (navGroups,
 * groupIcons), so the re-declaration is assignment-compatible in both directions.
 */
export interface LayoutOptions {
  toolboxBase: string;
  rightNavButtonTitle: string;
  rightNavDefaultRoute: string;
}

// Search result categories for enhanced omnibar
export enum SearchCategory {
  PAGES = "pages",
  PROJECTS = "projects",
  ACTIONS = "actions",
  RECENT = "recent",
  NAVIGATION = "navigation",
}

/**
 * Re-typed re-export (never subclassed - the library store calls
 * makeAutoObservable, which MobX rejects when a superclass sits on the
 * instance's prototype chain) so the constructor accepts this app's RootStore.
 */
type AppLayoutStoreCtor = new (
  rootStore: RootStore,
  layoutOptions: LayoutOptions
) => LibAppLayoutStore;

const AppLayoutStore = LibAppLayoutStore as unknown as AppLayoutStoreCtor;
type AppLayoutStore = LibAppLayoutStore;

export default AppLayoutStore;
